<template lang="pug">
	section#filtro
		.wrapper
			p Escolha seu tipo de graduação
			div.buttons
				button(@click="toggleTipo('grad')", :class="{ ativo: tipoC == 'grad' }") Graduação
				button(@click="toggleTipo('pos')", :class="{ ativo: tipoC == 'pos' }") Pós-Graduação
			p Qual a unidade mais próxima de mim?
			select(v-model="estadoC", name="selectEstados", :disabled="estados && !estados.length")
				option(:value="null") {{ estados.length ? `Estados` : `Carregando estados...` }}
				option(:value="estado.uf", v-for="estado in estados") {{ estado.nome }}
			select(v-model="cidadeC", name="selectCidades", :disabled="cidades && !cidades.length")
				option(:value="null", v-if="estadoC") {{ cidades.length ? `Cidades` : `Carregando cidades...` }}
				option(:value="null", v-else) Selecione um estado
				option(:value="cidade.nome | slugify", v-for="cidade in cidades") {{ cidade.nome }}
			p E adicione o seu endereço para ver o trajeto da unidade mais próxima
			.endereco
				include ../../../assets/svgs/icones/icone-pin-endereco.svg
				input(v-model="enderecoC", placeholder="Endereço")
				input(type="image", :src="require('@images/icones/icone-send.png')", @click="$emit('sendEndereco')").button_send
			p Agora é só clicar no Pin indicado no Mapa e anotar os dados do seu polo!
</template>

<script>
export default {
	name: "section-filtro",
	props: {
		tipo: {
			type: [String, null],
			default: 'grad'
		},
		estado: {
			type: [String, null],
			default: null
		},
		cidade: {
			type: [String, null],
			default: null
		},
		endereco: {
			type: [String, null],
			default: null
		},
		estados: {
			type: Array,
			default: () => []
		},
		cidades: {
			type: Array,
			default: () => []
		},
	},
	computed: {
		tipoC: {
			get() {
				return this.$props.tipo
			},
			set(tipo){
				this.$emit('update:tipo', tipo)
			}
		},
		estadoC: {
			get() {
				return this.$props.estado;
			},
			set(value) {
				let estado = this.estados.find(estado => estado.uf == value)
				if (value != null && estado && !estado.latlng.lat)
					estado.setLatLng().then(() => this.$emit('update:estado', value))
				else
					this.$emit('update:estado', value);
			}
		},
		cidadeC: {
			get() {
				return this.$props.cidade;
			},
			set(value) {
				let cidade = this.cidades.find(cidade => cidade.slug == value)
				if (value != null && cidade && !cidade.latlng.lat)
					cidade.setLatLng().then(() => this.$emit('update:cidade', value))
				else
					this.$emit('update:cidade', value)
			}
		},
		enderecoC: {
			get() {
				return this.$props.endereco;
			},
			set(value) {
				this.$emit('update:endereco', value)
			}
		},
	},
	methods: {
		toggleTipo(tipo) {
			this.tipoC = tipo
		}
	},
}
</script>

<style lang="stylus" scoped src="./Filtro.styl"></style>
